// Generated using typescript-generator version null on 2019-05-03 10:41:56.

import { NeqHttpClient as HttpClient } from './http-client.config';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { URN } from '@sharedcommon/model/urn.model';
import { SharedPagedRequest } from '@sharedcommon/model/shared-page-request.model';
import { SharedPagedResponse } from '@sharedcommon/model/shared-paged-response.model';
import { environment } from '@sharedenvironment';

export class TechnicalMetaDto {
  key?: string;
  value?: string;
}

export class RightDescriptionFilterDto extends SharedPagedRequest {
  rightCode?: string;
  domain?: string;
  description?: string;
  checkForRole?: string;
}

export class AbstractAuditableDto {
  modifiedBy?: string;
  modificationDate?: Date|string;
}

export class RightDescriptionDto extends AbstractAuditableDto {
  id?: string;
  rightCode?: string;
  domain?: string;
  description?: string;
  hasSearchedRole?: boolean;
}

export class HttpEntity<T> {
  headers?: { [index: string]: any };
  body?: T;
}

export class ResponseEntity<T> extends HttpEntity<T> {
  statusCodeValue?: number;
  statusCode?: HttpStatus;
}

export class EntityAssociationDto {
  code?: string;
  codeEntityAssociated?: string;
}

export class EntityDto extends AbstractAuditableDto {
  id?: string;
  code?: string;
  name?: string;
  logo: string;
  principalMatrix: URN;
  customer: URN;
  associatedEntities?: { [entityCode:string]: EntityDto }
  operatingModes?: string;
  hasSearchedUser?: boolean;
  rawmatExportEnabled?: boolean;
  winfourageExportEnabled?: boolean;
  rumineoExportEnabled?: boolean;
  rawmatExportFormat?: string;
  rawmatExportList?: string;
  limitExport: number;
  limitImport: number;
  types: string[];
}

export class EntityFilterDto extends SharedPagedRequest {
  allowedFor?: string;
  codes?: string[];
  name?: string;
  checkForUser?: string;
  matrixCode?: string;
}

export class RoleDto extends AbstractAuditableDto {
  id?: string;
  code?: string;
  label?: string;
  description?: string;
  activityCode?: string;
  admin?: boolean;
  hasSearchedRight?: boolean;
  hasSearchedUser?: boolean;
}

export class RoleFilterDto extends SharedPagedRequest {
  code?: string;
  label?: string;
  description?: string;
  admin?: boolean;
  checkForRightCode?: string;
  checkForUser?: string;
}

export class RoleRightDto {
  id?: string;
  codeRight?: string;
}

export class UserDto extends AbstractAuditableDto {
  id?: string;
  familyName?: string;
  givenName?: string;
  langCode?: string;
  email?: string;
  admin?: boolean;
  userMetas: UserMetaDto[];
  hasSearchedRole?: boolean;
  personalDataAcceptance?: any;
}

export class UserFilterDto extends SharedPagedRequest {
  familyName?: string;
  givenName?: string;
  email?: string;
  /**
   * To check if the user is connected to the entity ID
   */
  entityId?: string;
  checkForRoleCode?: string;
  active?: boolean;
  /**
   * if entityId is not null used to also include the associated entities
   */
  withAssociatedEntities?: boolean;
}

export class PatchDto<T> {
  op?: PatchOperation;
  path?: string;
  value?: T;
  from?: string;
}

export class UserMetaDto {
  key?: string;
  value?: string;
}

export class ActivityDto extends AbstractAuditableDto {
  id?: string;
  code?: string;
  label?: string;
}

export class EntityTypeDto {
  id: string;
  label: string;
  code: string;
}

@Injectable()
export class TechnicalServiceClient {

  constructor(protected httpClient: HttpClient) {
  }

  /**
   * HTTP GET /technical/metas/{key}
   * Java method: com.neovia.equadvice.common.service.TechnicalService.getMeta
   */
  getMeta(key: string): RestResponse<TechnicalMetaDto> {
    return this.httpClient.request({ method: 'GET', url: uriEncoding`technical/metas/${key}` });
  }

  /**
   * HTTP GET /technical/rights
   * Java method: com.neovia.equadvice.common.service.TechnicalService.getRights
   */
  getRights(): RestResponse<string[]> {
    return this.httpClient.request({ method: 'GET', url: uriEncoding`technical/rights` });
  }
}

@Injectable()
export class RightDescriptionServiceClient {

  constructor(protected httpClient: HttpClient) {
  }

  /**
   * Get filtered & paged right descriptions
   * Response code 206 - Partial ranged variables
   * Response code 404 - Not found
   * HTTP GET /right-descriptions
   * Java method: com.neovia.equadvice.identity.service.RightDescriptionService.fetch
   */
  fetch(arg0: RightDescriptionFilterDto): RestResponse<SharedPagedResponse<RightDescriptionDto>> {
    return this.httpClient.request({ method: 'GET', url: uriEncoding`right-descriptions`, data: arg0 });
  }

  /**
   * Get right description by id
   * Response code 200 - Obtained
   * Response code 404 - Not found
   * HTTP GET /right-descriptions/{id}
   * Java method: com.neovia.equadvice.identity.service.RightDescriptionService.get
   */
  get(id: string): RestResponse<RightDescriptionDto> {
    return this.httpClient.request({ method: 'GET', url: uriEncoding`right-descriptions/${id}` });
  }

  /**
   * Update right description
   * Response code 204 - Modified
   * Response code 404 - Not Found
   * Response code 500 - Error
   * HTTP PUT /right-descriptions/{id}
   * Java method: com.neovia.equadvice.identity.service.RightDescriptionService.update
   */
  update(id: string, arg1: RightDescriptionDto): RestResponse<any> {
    return this.httpClient.request({ method: 'PUT', url: uriEncoding`right-descriptions/${id}`, data: arg1 });
  }
}

@Injectable()
export class SubEntityServiceClient {

  constructor(protected httpClient: HttpClient) {
  }

  /**
   * Create entity association
   * Response code 201 - Created
   * Response code 500 - Error
   * HTTP POST /entities/{entityCode}/associations
   * Java method: com.neovia.equadvice.identity.service.SubEntityAssociationService.associationsCreate
   */
  associationsCreate(entityCode: string, arg0: EntityAssociationDto): RestResponse<any> {
    return this.httpClient.request({ method: 'POST', url: uriEncoding`entities/${entityCode}/associations`, data: arg0 });
  }

  /**
   * Delete entity association
   * Response code 202 - Deleted
   * Response code 500 - Error
   * HTTP DELETE /entities/{entityCode}/associations/{parentEntityCode}/{entityAssociatedCode}
   * Java method: com.neovia.equadvice.identity.service.SubEntityAssociationService.associationsDelete
   */
  associationsDelete(entityCode: string, parentEntityCode: string, entityAssociatedCode: string): RestResponse<any> {
    return this.httpClient.request({ method: 'DELETE', url: uriEncoding`entities/${entityCode}/associations/${parentEntityCode}/${entityAssociatedCode}` });
  }

  /**
   * Get all entity associations
   * Response code 200 - Obtained
   * Response code 404 - Not found
   * HTTP GET /entities/{entityCode}/associations
   * Java method: com.neovia.equadvice.identity.service.SubEntityAssociationService.associationsFetch
   */
  associationsFetch(entityCode: string, withCurrent: boolean = false, lightJson: boolean = false, inBusinessUnitCodes: string[] = []): RestResponse<EntityDto[]> {
    const data = {
      withCurrent: withCurrent,
      lightJson: lightJson,
      inBusinessUnitCodes: inBusinessUnitCodes
    }
    return this.httpClient.request({ method: 'GET', url: uriEncoding`entities/${entityCode}/associations`, data: data });
  }

  /**
   * Create entity
   * Response code 201 - Created
   * Response code 500 - Error
   * HTTP POST /entities
   * Java method: com.neovia.equadvice.identity.service.SubEntityService.create
   */
  create(arg0: EntityDto): RestResponse<any> {
    return this.httpClient.request({ method: 'POST', url: uriEncoding`entities`, data: arg0 });
  }

  /**
   * Delete entity
   * Response code 200 - Obtained
   * Response code 404 - Not found
   * HTTP DELETE /entities/{id}
   * Java method: com.neovia.equadvice.identity.service.SubEntityService.delete
   */
  delete(id: string): RestResponse<any> {
    return this.httpClient.request({ method: 'DELETE', url: uriEncoding`entities/${id}` });
  }

  /**
   * Get all entities
   * Response code 200 - Obtained
   * Response code 404 - Not found
   * HTTP GET /entities
   * Java method: com.neovia.equadvice.identity.service.SubEntityService.fetch
   */
  fetch(arg0: EntityFilterDto): RestResponse<SharedPagedResponse<EntityDto>> {
    return this.httpClient.request({ method: 'GET', url: uriEncoding`entities`, data: arg0 });
  }

  /**
   * Get Entity by id
   * Response code 200 - Obtained
   * Response code 404 - Not found
   * HTTP GET /entities/{id}
   * Java method: com.neovia.equadvice.identity.service.SubEntityService.get
   */
  get(id: string): RestResponse<EntityDto> {
    return this.httpClient.request({ method: 'GET', url: uriEncoding`entities/${id}` });
  }

  /**
   * Get Entity by code
   * Response code 200 - Obtained
   * Response code 404 - Not found
   * HTTP GET /entities/code/{code}
   * Java method: com.neovia.equadvice.identity.service.SubEntityService.getByCode
   */
  getByCode(code: string): RestResponse<EntityDto> {
    return this.httpClient.request({ method: 'GET', url: uriEncoding`entities/code/${code}` });
  }

  /**
   * Patch entity
   * Response code 200 - Modified
   * Response code 500 - Error
   * HTTP PATCH /entities/{id}
   * Java method: com.neovia.equadvice.identity.service.SubEntityService.patch
   */
  patch(id: string, arg1: PatchDto<any>[]): RestResponse<any> {
    return this.httpClient.request({ method: 'PATCH', url: uriEncoding`entities/${id}`, data: arg1 });
  }

  /**
   * Update entity
   * Response code 200 - Modify
   * Response code 500 - Error
   * HTTP PUT /entities
   * Java method: com.neovia.equadvice.identity.service.SubEntityService.put
   */
  put(arg0: EntityDto): RestResponse<any> {
    return this.httpClient.request({ method: 'PUT', url: uriEncoding`entities`, data: arg0 });
  }
}

@Injectable()
export class SubRoleServiceClient {

  constructor(protected httpClient: HttpClient) {
  }

  /**
   * Create role
   * Response code 201 - Created
   * Response code 409 - Conflict
   * Response code 500 - Error
   * HTTP POST /roles
   * Java method: com.neovia.equadvice.identity.service.SubRoleService.create
   */
  create(arg0: RoleDto): RestResponse<any> {
    return this.httpClient.request({ method: 'POST', url: uriEncoding`roles`, data: arg0 });
  }

  /**
   * Delete role
   * Response code 202 - Deleted
   * Response code 404 - Not Found
   * Response code 500 - Error
   * HTTP DELETE /roles/{id}
   * Java method: com.neovia.equadvice.identity.service.SubRoleService.delete
   */
  delete(id: string): RestResponse<void> {
    return this.httpClient.request({ method: 'DELETE', url: uriEncoding`roles/${id}` });
  }

  /**
   * Get filtered & paged roles
   * Response code 206 - Partial ranged variables
   * Response code 404 - Not found
   * HTTP GET /roles
   * Java method: com.neovia.equadvice.identity.service.SubRoleService.fetch
   */
  fetch(arg0: RoleFilterDto): RestResponse<SharedPagedResponse<RoleDto>> {
    return this.httpClient.request({ method: 'GET', url: uriEncoding`roles`, data: arg0 });
  }

  /**
   * Get role by id
   * Response code 200 - Obtained
   * Response code 404 - Not found
   * HTTP GET /roles/{id}
   * Java method: com.neovia.equadvice.identity.service.SubRoleService.get
   */
  get(id: string): RestResponse<RoleDto> {
    return this.httpClient.request({ method: 'GET', url: uriEncoding`roles/${id}` });
  }

  /**
   * Create role right
   * Response code 201 - Created
   * Response code 409 - Conflict
   * Response code 500 - Error
   * HTTP POST /roles/{role_id}/rights
   * Java method: com.neovia.equadvice.identity.service.SubRoleRightService.rightsCreate
   */
  rightsCreate(role_id: string, arg1: RoleRightDto): RestResponse<any> {
    return this.httpClient.request({ method: 'POST', url: uriEncoding`roles/${role_id}/rights`, data: arg1 });
  }

  /**
   * Delete role right
   * Response code 202 - Deleted
   * Response code 404 - Not Found
   * Response code 500 - Error
   * HTTP DELETE /roles/{role_id}/rights/{role_right_code}
   * Java method: com.neovia.equadvice.identity.service.SubRoleRightService.rightsDelete
   */
  rightsDelete(role_id: string, role_right_code: string): RestResponse<void> {
    return this.httpClient.request({ method: 'DELETE', url: uriEncoding`roles/${role_id}/rights/${role_right_code}` });
  }

  /**
   * Get role rights
   * Response code 200 - Obtained
   * Response code 404 - Not found
   * HTTP GET /roles/{role_id}/rights
   * Java method: com.neovia.equadvice.identity.service.SubRoleRightService.rightsGet
   */
  rightsGet(role_id: string): RestResponse<RoleRightDto[]> {
    return this.httpClient.request({ method: 'GET', url: uriEncoding`roles/${role_id}/rights` });
  }

  /**
   * Update role
   * Response code 204 - Modified
   * Response code 404 - Not Found
   * Response code 500 - Error
   * HTTP PUT /roles/{id}
   * Java method: com.neovia.equadvice.identity.service.SubRoleService.update
   */
  update(id: string, arg1: RoleDto): RestResponse<any> {
    return this.httpClient.request({ method: 'PUT', url: uriEncoding`roles/${id}`, data: arg1 });
  }
}

@Injectable()
export class SubUserServiceClient {

  constructor(protected httpClient: HttpClient) {
  }

  /**
   * Delete user
   * Response code 202 - Deleted
   * Response code 404 - Not Found
   * Response code 500 - Error
   * HTTP DELETE /users/{id}
   * Java method: com.neovia.equadvice.identity.service.SubUserService.delete
   */
  delete(id: string): RestResponse<void> {
    return this.httpClient.request({ method: 'DELETE', url: uriEncoding`users/${id}` });
  }
}

@Injectable()
export class TechnicalMetaServiceClient {

  constructor(protected httpClient: HttpClient) {
  }

  /**
   * Get default user validity time
   * Response code 200 - Obtained
   * Response code 404 - Not found
   * HTTP GET /technical-metas/user-validity
   * Java method: com.neovia.equadvice.identity.service.TechnicalMetaService.getDefaultUserValidityTime
   */
  getDefaultUserValidityTime(): RestResponse<number> {
    return this.httpClient.request({ method: 'GET', url: uriEncoding`technical-metas/user-validity` });
  }
}

@Injectable()
export class UserServiceClient {

  constructor(protected httpClient: HttpClient) {
  }

  /**
   * Create user
   * Response code 201 - Created
   * Response code 409 - Conflict
   * Response code 500 - Error
   * HTTP POST /users
   * Java method: com.neovia.equadvice.identity.service.UserService.create
   */
  create(arg0: UserDto): RestResponse<any> {
    return this.httpClient.request({ method: 'POST', url: uriEncoding`users`, data: arg0 });
  }

  /**
   * Add entity to user
   * Response code 201 - Created
   * Response code 409 - Conflict
   * Response code 500 - Error
   * HTTP POST /users/{user_id}/entities
   * Java method: com.neovia.equadvice.identity.service.SubUserEntityService.entitiesAdd
   */
  entitiesAdd(user_id: string, arg1: string): RestResponse<any> {
    return this.httpClient.request({ method: 'POST', url: uriEncoding`users/${user_id}/entities`, data: arg1 });
  }

  /**
   * Get user entities
   * Response code 200 - Obtained
   * Response code 404 - Not found
   * HTTP GET /users/{user_id}/entities
   * Java method: com.neovia.equadvice.identity.service.SubUserEntityService.entitiesGetUserEntities
   */
  entitiesGetUserEntities(user_id: string): RestResponse<EntityDto[]> {
    return this.httpClient.request({ method: 'GET', url: uriEncoding`users/${user_id}/entities` });
  }

  /**
   * Remove entity from user
   * Response code 202 - Deleted
   * Response code 404 - Not Found
   * Response code 500 - Error
   * HTTP DELETE /users/{user_id}/entities/{entity_id}
   * Java method: com.neovia.equadvice.identity.service.SubUserEntityService.entitiesRemove
   */
  entitiesRemove(user_id: string, entity_id: string): RestResponse<void> {
    return this.httpClient.request({ method: 'DELETE', url: uriEncoding`users/${user_id}/entities/${entity_id}` });
  }

  /**
   * Get filtered & paged users
   * Response code 206 - Partial ranged variables
   * Response code 404 - Not found
   * HTTP GET /users
   * Java method: com.neovia.equadvice.identity.service.UserService.fetch
   */
  fetch(arg0: UserFilterDto): RestResponse<SharedPagedResponse<UserDto>> {
    return this.httpClient.request({ method: 'GET', url: uriEncoding`users`, data: arg0 });
  }

  /**
   * Get GDPR text
   * Response code 200 - OK
   * Response code 500 - Error
   * HTTP GET /users/gdpr
   * Java method: com.neovia.equadvice.identity.service.UserService.gdpr
   */
  gdpr(queryParams?: { lang?: string; }): RestResponse<any> {
    return this.httpClient.request({ method: 'GET', url: uriEncoding`users/gdpr`, queryParams: queryParams });
  }

  /**
   * Get current user
   * Response code 200 - Obtained
   * Response code 404 - Not found
   * HTTP GET /users/me
   * Java method: com.neovia.equadvice.identity.service.UserService.getCurrentUser
   */
  getCurrentUser(): RestResponse<UserDto> {
    return this.httpClient.request({ method: 'GET', url: uriEncoding`users/me` });
  }

  /**
   * Get current user activities
   * Response code 200 - Obtained
   * Response code 404 - Not found
   * HTTP GET /users/me/activities
   * Java method: com.neovia.equadvice.identity.service.UserService.getCurrentUserActivities
   */
  getCurrentUserActivities(): RestResponse<ActivityDto[]> {
    return this.httpClient.request({ method: 'GET', url: uriEncoding`users/me/activities` });
  }

  /**
   * Get current user entities
   * Response code 200 - Obtained
   * Response code 404 - Not found
   * HTTP GET /users/me/entities
   * Java method: com.neovia.equadvice.identity.service.UserService.getCurrentUserEntities
   */
  getCurrentUserEntities(queryParams?: { activityCode?: string; }): RestResponse<EntityDto[]> {
    return this.httpClient.request({ method: 'GET', url: uriEncoding`users/me/entities`, queryParams: queryParams });
  }

  /**
   * Get user by uuid
   * Response code 200 - Obtained
   * Response code 404 - Not found
   * HTTP GET /users/{user_uuid}
   * Java method: com.neovia.equadvice.identity.service.UserService.getUser
   */
  getUser(user_uuid: string): RestResponse<UserDto> {
    return this.httpClient.request({ method: 'GET', url: uriEncoding`users/${user_uuid}` });
  }

  /**
   * Get user activities
   * Response code 200 - Obtained
   * Response code 404 - Not found
   * HTTP GET /users/{user_uuid}/activities
   * Java method: com.neovia.equadvice.identity.service.UserService.activitiesGetUserActivities
   */
  activitiesGetUserActivities(user_uuid: string): RestResponse<string[]> {
    return this.httpClient.request({ method: 'GET', url: uriEncoding`users/${user_uuid}/activities` });
  }

  /**
   * Get user rights from his roles
   * Response code 200 - Obtained
   * Response code 404 - Not found
   * HTTP GET /users/{user_uuid}/rights
   * Java method: com.neovia.equadvice.identity.service.UserService.rightsGetUserRights
   */
  rightsGetUserRights(user_uuid: string): RestResponse<string[]> {
    return this.httpClient.request({ method: 'GET', url: uriEncoding`users/${user_uuid}/rights` });
  }

  /**
   * Get user metas
   * Response code 200 - Obtained
   * Response code 404 - Not found
   * HTTP GET /users/me/metas
   * Java method: com.neovia.equadvice.identity.service.SubUserMetaService.metasFetch
   */
  metasFetch(): RestResponse<UserMetaDto[]> {
    return this.httpClient.request({ method: 'GET', url: uriEncoding`users/me/metas` });
  }

  /**
   * Patch metas to user
   * Response code 204 - Patched
   * Response code 500 - Error
   * HTTP PATCH /users/me/metas/{key}
   * Java method: com.neovia.equadvice.identity.service.SubUserMetaService.metasPatch
   */
  metasPatch(key: string, arg1: PatchDto<string>[]): RestResponse<any> {
    return this.httpClient.request({ method: 'PATCH', url: uriEncoding`users/me/metas/${key}`, data: arg1 });
  }

  /**
   * Patch User
   * Response code 204 - Modified
   * Response code 404 - Not Found
   * Response code 500 - Error
   * HTTP PATCH /users/me
   * Java method: com.neovia.equadvice.identity.service.UserService.patchCurrentUser
   */
  patchCurrentUser(arg0: PatchDto<any>[]): RestResponse<any> {
    return this.httpClient.request({ method: 'PATCH', url: uriEncoding`users/me`, data: arg0 });
  }

  /**
   * Remove lang from users
   * Response code 202 - Removed
   * Response code 500 - Error
   * HTTP DELETE /users/lang/{langCode}
   * Java method: com.neovia.equadvice.identity.service.UserService.removeLangFromUsers
   */
  removeLangFromUsers(langCode: string): RestResponse<void> {
    return this.httpClient.request({ method: 'DELETE', url: uriEncoding`users/lang/${langCode}` });
  }

  /**
   * Add role to user
   * Response code 201 - Created
   * Response code 409 - Conflict
   * Response code 500 - Error
   * HTTP POST /users/{user_id}/roles
   * Java method: com.neovia.equadvice.identity.service.SubUserRoleService.rolesAdd
   */
  rolesAdd(user_id: string, arg1: string): RestResponse<any> {
    return this.httpClient.request({ method: 'POST', url: uriEncoding`users/${user_id}/roles`, data: arg1 });
  }

  /**
   * Remove role from user
   * Response code 202 - Deleted
   * Response code 404 - Not Found
   * Response code 500 - Error
   * HTTP DELETE /users/{user_id}/roles/{role_id}
   * Java method: com.neovia.equadvice.identity.service.SubUserRoleService.rolesRemove
   */
  rolesRemove(user_id: string, role_id: string): RestResponse<void> {
    return this.httpClient.request({ method: 'DELETE', url: uriEncoding`users/${user_id}/roles/${role_id}` });
  }

  /**
   * Update user
   * Response code 204 - Modified
   * Response code 404 - Not Found
   * Response code 500 - Error
   * HTTP PUT /users/{id}
   * Java method: com.neovia.equadvice.identity.service.UserService.update
   */
  update(id: string, arg1: UserDto): RestResponse<any> {
    return this.httpClient.request({ method: 'PUT', url: uriEncoding`users/${id}`, data: arg1 });
  }
}

@Injectable()
export class EntityTypeServiceClient {

  constructor(protected httpClient: HttpClient) {  }

  fetch(): RestResponse<EntityTypeDto[]> {
    return this.httpClient.request({ method: 'GET', url: uriEncoding`entity/types` })
  }
}

export type RestResponse<R> = Observable<R>;

export type TextMatchMode = 'STRICT' | 'CONTAINS';

export type HttpStatus = 'CONTINUE' | 'SWITCHING_PROTOCOLS' | 'PROCESSING' | 'CHECKPOINT' | 'OK' | 'CREATED' | 'ACCEPTED' | 'NON_AUTHORITATIVE_INFORMATION' | 'NO_CONTENT' | 'RESET_CONTENT' | 'PARTIAL_CONTENT' | 'MULTI_STATUS' | 'ALREADY_REPORTED' | 'IM_USED' | 'MULTIPLE_CHOICES' | 'MOVED_PERMANENTLY' | 'FOUND' | 'MOVED_TEMPORARILY' | 'SEE_OTHER' | 'NOT_MODIFIED' | 'USE_PROXY' | 'TEMPORARY_REDIRECT' | 'PERMANENT_REDIRECT' | 'BAD_REQUEST' | 'UNAUTHORIZED' | 'PAYMENT_REQUIRED' | 'FORBIDDEN' | 'NOT_FOUND' | 'METHOD_NOT_ALLOWED' | 'NOT_ACCEPTABLE' | 'PROXY_AUTHENTICATION_REQUIRED' | 'REQUEST_TIMEOUT' | 'CONFLICT' | 'GONE' | 'LENGTH_REQUIRED' | 'PRECONDITION_FAILED' | 'PAYLOAD_TOO_LARGE' | 'REQUEST_ENTITY_TOO_LARGE' | 'URI_TOO_LONG' | 'REQUEST_URI_TOO_LONG' | 'UNSUPPORTED_MEDIA_TYPE' | 'REQUESTED_RANGE_NOT_SATISFIABLE' | 'EXPECTATION_FAILED' | 'I_AM_A_TEAPOT' | 'INSUFFICIENT_SPACE_ON_RESOURCE' | 'METHOD_FAILURE' | 'DESTINATION_LOCKED' | 'UNPROCESSABLE_ENTITY' | 'LOCKED' | 'FAILED_DEPENDENCY' | 'UPGRADE_REQUIRED' | 'PRECONDITION_REQUIRED' | 'TOO_MANY_REQUESTS' | 'REQUEST_HEADER_FIELDS_TOO_LARGE' | 'UNAVAILABLE_FOR_LEGAL_REASONS' | 'INTERNAL_SERVER_ERROR' | 'NOT_IMPLEMENTED' | 'BAD_GATEWAY' | 'SERVICE_UNAVAILABLE' | 'GATEWAY_TIMEOUT' | 'HTTP_VERSION_NOT_SUPPORTED' | 'VARIANT_ALSO_NEGOTIATES' | 'INSUFFICIENT_STORAGE' | 'LOOP_DETECTED' | 'BANDWIDTH_LIMIT_EXCEEDED' | 'NOT_EXTENDED' | 'NETWORK_AUTHENTICATION_REQUIRED';

export type PatchOperation = 'ADD' | 'REMOVE' | 'REPLACE' | 'COPY' | 'MOVE' | 'TEST';

function uriEncoding(template: TemplateStringsArray, ...substitutions: any[]): string {
  let result = environment.identity.baseUrl;
  for (let i = 0; i < substitutions.length; i++) {
    result += template[i];
    result += encodeURIComponent(substitutions[i]);
  }
  result += template[template.length - 1];
  return result;
}
